// Shared chat rendering surface used by ChatView.
// Owns the message list and fetch-disabled flag loading. The file dropzone
// (drop target + overlay) lives in MainLayoutFrame so it spans the chat column
// and the widgets drawer; this component wires the composer into it via
// ChatDropzoneContext. Route parsing, channel lookup, and document title stay
// in the route-specific view shells that mount this component.
import React, { useContext, useMemo } from 'react';

import { getMetaContent } from '../../../lib/meta';

import { ChatDropzoneContext } from '../../../contexts/ChatDropzoneContext';
import MessageFeed from '../../../feed/ui/MessageFeed';

const ChatSurface = ({ currentChannel, currentChannelBreadcrumbs = [] }) => {
  const messageMaxMediaAttachments = useMemo(() => parseInt(getMetaContent('message:max_media_attachments')), []);
  const messageMaxRichdownContentSize = useMemo(() => parseInt(getMetaContent('message:max_richdown_content_size')), []);
  const { dropzoneHelpers, handleDropzoneStateChange, handleUploadCountChange } = useContext(ChatDropzoneContext) ?? {};

  return (
    <div className="@container relative flex size-full min-h-0 flex-col overflow-hidden">
      <div className="mx-auto size-full">
        <div className="h-full">
          <MessageFeed
            currentChannel={currentChannel}
            currentChannelBreadcrumbs={currentChannelBreadcrumbs}
            dropzoneHelpers={dropzoneHelpers}
            handleDropzoneStateChange={handleDropzoneStateChange}
            handleUploadCountChange={handleUploadCountChange}
            maxMediaAttachments={messageMaxMediaAttachments}
            maxRichdownContentSize={messageMaxRichdownContentSize}
          />
        </div>
      </div>
    </div>
  );
};

export default ChatSurface;
